import React, { Component } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from '../../actions/loginActions';
import { CAPTCHA_SITE_KEY } from "../../actions/constant";
import Recaptcha from 'react-google-invisible-recaptcha';
import { bootGuestIntercom, shutdownGuestIntercom } from "../../utils";
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";

const sitekey = CAPTCHA_SITE_KEY;
class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.captcha = React.createRef(); 
    }
    
    state = {
        accountEmailId: null,
        emailError: null,
        emailErrorMessage: null,
        success: null,
        loader : false,
        reCaptcha: localStorage.getItem('_grecaptcha') ? localStorage.getItem('_grecaptcha') : null,
    }
 
    
    componentDidMount() {
        bootGuestIntercom();
    }

    componentWillUnmount() {
        shutdownGuestIntercom();
    }

    onEmailTextChange = event => {
        this.setState({ accountEmailId: event.target.value, emailError: null, emailErrorMessage: null })
    }

    onReCaptcha = (value) => this.setState({ reCaptcha: value })

    onClickToForgot = event => {
        const { accountEmailId, loader, reCaptcha} = this.state;
        const { activeProduct } = this.props
        var self = this;
        if (accountEmailId && String(accountEmailId).length > 0 && !loader && reCaptcha) {

            self.setState({loader:true})   
            forgotPassword({ emailId: accountEmailId, activeProduct }).then((response) => {
                self.setState({ success: true, emailErrorMessage: null, loader:false })
            }).catch((ex) => {
                self.setState({ loader:false, emailError: true, emailErrorMessage: `Couldn't find your account with this e-mail` })
            })
        }
        else {
            if (reCaptcha == null && accountEmailId) this.recaptcha.execute()
            this.setState({ emailError: !(accountEmailId && String(accountEmailId).length > 0) })
        }
    }

    onResolved = () => {
        const recaptcha = this.recaptcha.getResponse()
        this.setState({ reCaptcha : recaptcha },()=>{ localStorage.setItem('_grecaptcha',recaptcha); this.onClickToForgot()})
      }


    render() {
        const { prefix } = this.props
        const { accountEmailId, emailError, success, emailErrorMessage, loader, reCaptcha } = this.state
        return <>
            <div className="loginFormSec registerFormSec formControlMin">
                 <div className="loginBlock">
                    <div className="loginInnSec">
                        <div className="loginHead">
                            <h2>Forgot Password</h2>
                            <p>For existing user</p>
                        </div>

                        <p className="text-center"><strong>Enter your email address below to reset your password.</strong></p>

                        <div className="spacer10px"></div>
                        {success ? <div id="flashFlushMessage" className="note note-success">
                            <p className="mb-0">
                                Success! Please check your e-mail to reset your password.	</p>
                        </div> : null}
                        <div className="spacer15px"></div>

                        <div id="AccountForgotpasswordForm" >
                            <div className="form-group labelPosition">
                                <label htmlFor="AccountEmailId">Email Id</label>
                                <div className="email-input-wrapper">
                                    <input name="data[Account][emailId]" className={`form-control placeholder-no-fix email-input ${emailError ? `form-error` : ``}`} maxlength="255" type="email" id="AccountEmailId" value={accountEmailId} onChange={this.onEmailTextChange} placeholder="name@work-email.com" />
                                    <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'email-input-icon'} />
                                </div>
                                {emailError ? <div className="error-message">{emailErrorMessage && emailErrorMessage.length > 0 ? emailErrorMessage : `Email is required.`}</div> : null}
                            </div>
                            <div  className="form-group recaptchaSec d-none">
                                 <Recaptcha
                                    ref={ ref => this.recaptcha = ref }
                                    sitekey={sitekey}
                                    onResolved={ this.onResolved } />
                                {reCaptcha == false ? <div className="error-message">Please verify that you are not a robot.</div> : null}
                            </div>
                            <div className="form-group">
                                <button className={`btn btn-primary w-100 ${loader ? ' disabled' : ''}`} data-style="expand-left" onClick={this.onClickToForgot}><span className="ladda-label changeText" style={{ display: loader ? 'none' : 'block' }}>Submit</span>
                                    <span className="indicator-progress" style={{ display: !loader ? 'none' : 'block' }}> Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                            <div className="form-group">
                                <p>Take me back to <Link to={`${prefix}accounts/login`} className="btnSignUp">Login</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}

export default ForgotPassword